<template>
    <div class="sms-requests">
        <header class="sms-requests__header">
            <div>
                <h1>SMS-рассылки</h1>
                <p>Заявки на таргетированную рассылку. К кампаниям не привязаны.</p>
            </div>
            <a v-if="createUrl" :href="createUrl" class="btn btn--primary">Новая заявка</a>
        </header>
        <p v-if="error" class="field__error">{{ error }}</p>
        <p v-else-if="loading">Загрузка…</p>
        <p v-else-if="requests.length === 0">Заявок пока нет.</p>
        <table v-else class="sms-requests__table">
            <thead>
                <tr>
                    <th>Название</th>
                    <th>Клиент</th>
                    <th>Бренд</th>
                    <th>Период</th>
                    <th>Отправка</th>
                    <th>Владелец</th>
                    <th>Создана</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in requests" :key="item.id">
                    <td><a :href="item.urls.edit">{{ item.name }}</a></td>
                    <td>{{ item.client_name }}</td>
                    <td>{{ item.brand_name }}</td>
                    <td>{{ item.period }}</td>
                    <td>{{ item.status_label }}</td>
                    <td>{{ item.owner || '—' }}</td>
                    <td>{{ item.created_at || '—' }}</td>
                    <td class="sms-requests__actions">
                        <button v-if="item.can_edit" type="button" class="btn btn--secondary btn--small" @click="remove(item)">
                            Удалить
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import axios from 'axios';
import { confirmAction } from '../../../composables/useConfirm';
import { extractErrorMessage } from '../../../utils/httpErrors';

defineProps({
    createUrl: { type: String, default: '' },
});

const requests = ref([]);
const loading = ref(true);
const error = ref('');

const load = async () => {
    loading.value = true;
    error.value = '';
    try {
        const { data } = await axios.get('/rtb/sms-requests/data');
        requests.value = data.requests || [];
    } catch (loadError) {
        error.value = extractErrorMessage(loadError, 'Не удалось загрузить заявки');
    } finally {
        loading.value = false;
    }
};

const remove = async (item) => {
    const confirmed = await confirmAction({
        title: `Удалить заявку «${item.name}»?`,
        message: 'Документы уже отправленных заявок в Telegram останутся. Сама заявка и история отправок будут удалены.',
        confirmLabel: 'Удалить',
        tone: 'danger',
    });
    if (!confirmed) return;
    try {
        await axios.delete(item.urls.destroy);
        await load();
    } catch (deleteError) {
        error.value = extractErrorMessage(deleteError, 'Не удалось удалить заявку');
    }
};

onMounted(load);
</script>

<style scoped lang="scss">
.sms-requests {
    max-width: 1200px;
    margin: 0 auto;
    padding: 24px;
}

.sms-requests__header {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: flex-start;
    margin-bottom: 16px;

    h1 {
        margin: 0 0 4px;
    }

    p {
        margin: 0;
        color: #6b7280;
    }
}

.sms-requests__table {
    width: 100%;
    border-collapse: collapse;
    background: #fff;

    th, td {
        padding: 10px 12px;
        border-bottom: 1px solid #e5e7eb;
        text-align: left;
        vertical-align: top;
    }
}

.sms-requests__actions {
    text-align: right;
}
</style>
